<div class="row">
  <div class="col-7">
    <div class="field-label" i18n>Job ID</div>
    <div>{{ results.job_id || results.jobId }}</div>
  </div>
  <div class="col-5">
    <div class="field-label" i18n>Created At</div>
    <div *ngIf="results.createdAt">{{ results.createdAt | date: 'medium' }}</div>
    <div *ngIf="!results.createdAt" class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-7">
    <div class="field-label" i18n>Job Status</div>
    <div *ngIf="results.status">{{ results.status }}</div>
    <div *ngIf="!results.status" class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
  <div class="col-5">
    <div class="field-label" i18n>Started At</div>
    <div *ngIf="results.startedAt">{{ results.startedAt | date: 'medium' }}</div>
    <div *ngIf="!results.startedAt" class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-7">
    <div class="field-label" i18n>Job Name</div>
    <div *ngIf="results.jobName">{{ results.jobName }}</div>
    <div *ngIf="!results.jobName" class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
  <div class="col-5">
    <div class="field-label" i18n>Stopped At</div>
    <div *ngIf="results.stoppedAt">{{ results.stoppedAt | date: 'medium' }}</div>
    <div *ngIf="!results.stoppedAt" class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</div>
<div class="mt-3 d-flex justify-content-end">
  <button nbButton status="danger" [disabled]="['SUCCEEDED', 'FAILED'].includes(results.status)" (click)="stop()" i18n>
    Stop
  </button>
</div>
